import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=22d2941a&"
import script from "./UserSettings.vue?vue&type=script&lang=ts&"
export * from "./UserSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports